export enum SeverityEnum {
    LOW = "low",
    MODERATE = "moderate",
    HIGH = "high",
    CRITICAL = "critical",
}


export enum Reason {
    BAD_COMBINATION = "Bad Combination",
    RESOURCE_NOT_FOUND = "Resource Missing"
}